module.exports = __webpack_public_path__ + "static/media/icon_add.d7c721b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_add.svg
// module id = 771
// module chunks = 0